export const opening = [
  'O mercado de Fundos de Investimento Imobiliario encerrou 2025 em um patamar que demonstra ao mesmo tempo a maturidade alcancada e os desafios de um ambiente macroeconomico adverso. Apos o pico historico de emissoes em 2021, o mercado primario passou por um ciclo de acomodacao, e 2025 nao fugiu a essa tendencia: o volume captado recuou para R$ 44,02 bilhoes. O cenario de juros elevados, com a Selic pressionada ao longo do ano, reduziu a atratividade relativa dos FIIs frente a renda fixa e diminuiu o apetite de emissores e investidores no mercado primario.',
  'No mercado secundario, porem, a trajetoria foi diferente. O volume negociado alcancou R$ 93,76 bilhoes em 2025, mantendo-se no patamar elevado inaugurado em 2024. O numero de negocios, que atingiu 153,9 milhoes, tambem permaneceu em nivel alto, embora cerca de 30 milhoes de negocios tenham desaparecido entre 2024 e 2025.',
  'O estoque de patrimonio liquido dos FIIs seguiu sua trajetoria de crescimento estrutural. A serie historica de PL, em ascensao continua desde 2020, supera R$ 400 bilhoes em 2025, sustentada pela expansao da base de fundos e pelo reinvestimento de rendimentos em um universo cada vez mais diversificado de ativos. A composicao por tipo de ativo revela a dominancia dos FIIs de Imoveis e a ascensao dos FIIs Multiclasse, que ganharam participacao no periodo de juros altos.',
  'Este anuario analisa em detalhe cada uma dessas dimensoes: mercado primario de emissoes, mercado secundario, estoque patrimonial em suas multiplas aberturas e ranking dos principais participantes. Os dados cobrem o periodo de 2019 a 2025, permitindo uma leitura historica consistente das transformacoes do setor.',
  'Ao longo das proximas secoes, o leitor encontrara uma radiografia completa do mercado de FII em 2025: um setor que, mesmo diante das adversidades ciclicas, consolidou seu papel como principal veiculo de democratizacao do investimento imobiliario no Brasil.',
];

export const primaryMarket = {
  intro: [
    'O mercado primario de FII em 2025 refletiu o impacto do ciclo de aperto monetario sobre a capacidade de captacao do setor. Com a taxa Selic em niveis elevados durante a maior parte do ano, a competicao com instrumentos de renda fixa de baixo risco desincentivou a estruturacao de novos fundos e as ofertas subsequentes dos FIIs existentes.',
    'As emissoes de FII atingiram R$ 44,02 bilhoes em 2025, queda de 7,1% em relacao aos R$ 47,40 bilhoes de 2024. Trata-se do segundo ano consecutivo de recuo, consolidando a desaceleracao iniciada apos o pico historico de R$ 51,28 bilhoes em 2021.',
  ],
  charts: [
    {
      title: 'EMISSOES DE FII',
      link: 'https://metabase.uqbaronline.com/question/147-emissoes-dos-fiis',
      description:
        'As emissoes de FII somaram R$ 44,02 bilhoes em 2025, abaixo dos R$ 47,40 bilhoes de 2024. A serie historica mostra forte sensibilidade ao ciclo de juros: expansao entre 2019 e 2021, e acomodacao a partir de 2022 com o aperto monetario.',
      data: [
        { ano: '2019', montante_emitido: 40909578049.34 },
        { ano: '2020', montante_emitido: 48108831911.43 },
        { ano: '2021', montante_emitido: 51284680856.64 },
        { ano: '2022', montante_emitido: 37043354750.97 },
        { ano: '2023', montante_emitido: 34105103836.64 },
        { ano: '2024', montante_emitido: 47401610097.58 },
        { ano: '2025', montante_emitido: 44018707769.49 },
      ],
    },
    {
      title: 'EMISSOES DE FII POR TIPO DE ATIVO',
      link: 'https://metabase.uqbaronline.com/question/148-emissoes-de-fii-por-tipo-de-ativo',
      description:
        'A composicao por tipo de ativo mostra perda relativa da categoria Renda Fixa em termos absolutos e relativos, enquanto os FIIs de Imovel fisico preservaram espaco. A categoria Multiclasse avancou com estruturas mais flexiveis, e o FIAGRO manteve presenca no periodo.',
      data: [
        { ano: '2019', tipo_ativo: 'Imovel', montante_emitido: 27215946081.3 },
        {
          ano: '2019',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 981344830.26,
        },
        {
          ano: '2019',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 9178237200.84,
        },
        {
          ano: '2019',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 3534049936.94,
        },
        { ano: '2020', tipo_ativo: 'Imovel', montante_emitido: 30769216098.23 },
        {
          ano: '2020',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 933591295.31,
        },
        {
          ano: '2020',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 10952887153.33,
        },
        {
          ano: '2020',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 5453137364.57,
        },
        { ano: '2021', tipo_ativo: 'FIAGRO', montante_emitido: 2179226533.7 },
        { ano: '2021', tipo_ativo: 'Imovel', montante_emitido: 23252032353.41 },
        {
          ano: '2021',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 1538938614.74,
        },
        {
          ano: '2021',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 20550996189.48,
        },
        {
          ano: '2021',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 3763487165.3,
        },
        { ano: '2022', tipo_ativo: 'FIAGRO', montante_emitido: 6673152928.95 },
        { ano: '2022', tipo_ativo: 'Imovel', montante_emitido: 13121412487.91 },
        {
          ano: '2022',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 1939089217.76,
        },
        {
          ano: '2022',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 12523973637.5,
        },
        {
          ano: '2022',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 2785726478.85,
        },
        { ano: '2023', tipo_ativo: 'FIAGRO', montante_emitido: 6791878663.67 },
        { ano: '2023', tipo_ativo: 'Imovel', montante_emitido: 13189803423.43 },
        {
          ano: '2023',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 2729995504.93,
        },
        {
          ano: '2023',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 6505859498.26,
        },
        {
          ano: '2023',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 4887566746.35,
        },
        { ano: '2024', tipo_ativo: 'FIAGRO', montante_emitido: 1810649092.67 },
        { ano: '2024', tipo_ativo: 'Imovel', montante_emitido: 21845902290.96 },
        {
          ano: '2024',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 3567897213.46,
        },
        {
          ano: '2024',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 13864710603.86,
        },
        {
          ano: '2024',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 6312450896.63,
        },
        { ano: '2025', tipo_ativo: 'FIAGRO', montante_emitido: 891026617.95 },
        { ano: '2025', tipo_ativo: 'Imovel', montante_emitido: 20941071888.34 },
        {
          ano: '2025',
          tipo_ativo: 'Multiclasse',
          montante_emitido: 6633551675.78,
        },
        {
          ano: '2025',
          tipo_ativo: 'Nao informado',
          montante_emitido: 14737321.57,
        },
        {
          ano: '2025',
          tipo_ativo: 'Renda Fixa',
          montante_emitido: 9377396323.67,
        },
        {
          ano: '2025',
          tipo_ativo: 'Renda Variavel',
          montante_emitido: 6160923942.19,
        },
      ],
    },
  ],
};

export const secondaryMarket = {
  intro: [
    'O mercado secundario de cotas de FII consolidou em 2025 um patamar de maturidade e liquidez que seria inimaginavel ha menos de uma decada. A expansao da base de investidores pessoas fisicas criou condicoes para um volume expressivo de negociacao mesmo em anos de menor apetite primario.',
    'Em 2025, o secundario foi marcado pela tensao entre o yield elevado dos FIIs de papel, sustentado pelos juros altos, e a pressao negativa sobre as cotas de fundos de tijolo. Esse ambiente elevou a rotatividade das carteiras e sustentou um numero de negocios ainda elevado no ano.',
  ],
  charts: [
    {
      title: 'MERCADO SECUNDARIO DE FII',
      link: 'https://metabase.uqbaronline.com/dashboard/13-secundario',
      description:
        'O montante negociado ficou em R$ 93,76 bilhoes em 2025, praticamente estavel frente aos R$ 93,98 bilhoes de 2024. O numero de negocios caiu para 153,9 milhoes, ainda o segundo maior da serie historica e muito acima dos 15,6 milhoes observados em 2019.',
      data: [
        {
          ano: '2019',
          montante_negociado: 32497658935.47,
          numero_negocios: 15566616,
        },
        {
          ano: '2020',
          montante_negociado: 54626403429.98,
          numero_negocios: 37026327,
        },
        {
          ano: '2021',
          montante_negociado: 66843249703.99,
          numero_negocios: 66939513,
        },
        {
          ano: '2022',
          montante_negociado: 63576968822.57,
          numero_negocios: 101601856,
        },
        {
          ano: '2023',
          montante_negociado: 69202999697.42,
          numero_negocios: 137144578,
        },
        {
          ano: '2024',
          montante_negociado: 93983855131.29,
          numero_negocios: 184494484,
        },
        {
          ano: '2025',
          montante_negociado: 93761802819.67,
          numero_negocios: 153950611,
        },
      ],
    },
  ],
};

export const stock = {
  intro: [
    'O patrimonio liquido consolidado dos FIIs atingiu, em 2025, o nivel mais elevado de toda a serie historica, superando R$ 400 bilhoes. A trajetoria ascendente continua do PL sem retracao nominal desde 2020 reforca o carater estrutural de crescimento do setor.',
    'Novas emissoes, reinvestimento de rendimentos, valorizacao de ativos e a chegada constante de novos fundos sustentaram a expansao do estoque mesmo em um ano de menor captacao. A composicao do PL mostra uma industria diversificada por tipo de ativo e tipo de gestao.',
  ],
  charts: [
    {
      title: 'PL DOS FIIS',
      link: 'https://metabase.uqbaronline.com/question/141-patrimonio-liquido-dos-fiis',
      description:
        'A trajetoria do PL foi de crescimento quase ininterrupto, saindo de cerca de R$ 100 bilhoes no inicio de 2020 para superar R$ 400 bilhoes no fim de 2025. O numero de fundos tambem avancou de forma consistente, ultrapassando 1.200 veiculos na ponta final da serie.',
      data: [
        { ano: '2019', pl_total: 133815967250.29, numero_fundos: 468 },
        { ano: '2020', pl_total: 176552872817.47, numero_fundos: 563 },
        { ano: '2021', pl_total: 219866795294.98, numero_fundos: 699 },
        { ano: '2022', pl_total: 254074507404.4, numero_fundos: 806 },
        { ano: '2023', pl_total: 312821353731.0, numero_fundos: 922 },
        { ano: '2024', pl_total: 349187509374.6, numero_fundos: 1064 },
        { ano: '2025', pl_total: 414221309674.12, numero_fundos: 1221 },
      ],
    },
    {
      title: 'PL POR TIPO DE ATIVO',
      link: 'https://metabase.uqbaronline.com/question/142-patrimonio-liquido-por-tipo-de-ativo',
      description:
        'A Renda Fixa ampliou participacao ao longo da serie, enquanto os FIIs de Imovel mantiveram relevancia com perda relativa de espaco. A classe Multiclasse ganhou tracao a partir de 2023, sinalizando busca por estruturas mais versateis para diferentes ciclos de mercado.',
      data: [
        { tipo_ativo: 'Imovel', pl_total: 247039637227.4 },
        { tipo_ativo: 'Renda Fixa', pl_total: 84138799532.98 },
        { tipo_ativo: 'Multiclasse', pl_total: 41341739227.75 },
        { tipo_ativo: 'Renda Variavel', pl_total: 38185352875.47 },
        { tipo_ativo: 'Nao informado', pl_total: 2678327652.78 },
        { tipo_ativo: 'FIAGRO', pl_total: 837453157.74 },
      ],
    },
    {
      title: 'PL POR TIPO DE GESTAO',
      link: 'https://metabase.uqbaronline.com/question/144-patrimonio-liquido-por-tipo-de-gestao',
      description:
        'A Gestao Ativa manteve dominancia ampla ao longo de toda a serie, concentrando a maior parte do PL dos FIIs. A Gestao Passiva permaneceu com fatia menor, mas consistente, atendendo ao perfil de investidor que prioriza previsibilidade de carteira e menor custo.',
      data: [
        { tipo_gestao: 'Gestao Ativa', pl_total: 371474036727.62 },
        { tipo_gestao: 'Gestao Passiva', pl_total: 42417820827.28 },
        { tipo_gestao: 'Nao informado', pl_total: 329452119.22 },
      ],
    },
  ],
};

const rankingBaseUrl = `${process.env.REACT_APP_PUBLIC_URL}/rankings/dados`;

export const rankings = {
  intro: [
    'Os Rankings Uqbar sintetizam o desempenho do mercado de FII em 2025 em diferentes criterios: volume emitido, patrimonio, desempenho de cotas e capitalizacao de mercado. A leitura conjunta evidencia concentracao de captacao em poucos fundos de grande porte e a dominancia persistente de um grupo reduzido de administradores e gestores no patrimonio total da industria.',
    'Em um ano de desaceleracao no primario, os rankings mostram quais participantes conseguiram estruturar ofertas atrativas e quais nomes se destacaram no secundario por liquidez, dividend yield e rentabilidade efetiva.',
  ],
  items: [
    {
      title: 'Ranking de FII por Montante Emitido em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafiiallmarket&criteria=amountissued&timeRange=yearly`,
      pending: false,
      description:
        'Iridium liderou o ranking com 6,36% e R$ 2,80 bilhoes, seguido por Hedge Brasil Shopping (5,79% / R$ 2,55 bi) e Kinea Rendimentos Imobiliarios (4,37% / R$ 1,92 bi).',
    },
    {
      title: 'Ranking de Advogados por Montante Emitido em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=legaladvisor&criteria=amount&timeRange=yearly`,
      pending: false,
      description:
        'Cescon Barrieu liderou com 31,76% e R$ 1,07 bilhao, seguido por Stocche Forbes com 30,78% e R$ 1,04 bilhao. Os dois primeiros concentraram mais de 62% do volume assessorado.',
    },
    {
      title: 'Ranking de Advogados por Numero de Operacoes em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=legaladvisor&criteria=operations&timeRange=yearly`,
      pending: false,
      description:
        'No criterio de numero de operacoes, NFA liderou com 5 operacoes (26,32%), enquanto Cescon Barrieu e PMK dividiram a sequencia com 3 operacoes cada.',
    },
    {
      title: 'Ranking de Cotas de FII por Montante Negociado em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=amountnegotiated&timeRange=yearly`,
      pending: false,
      description:
        'Oportunidades Imobiliarias I RLtda (Subordinada) liderou com 44,51% e R$ 2,73 bilhoes, seguido pela Subclasse Senior do mesmo fundo com 16,36% e R$ 1,01 bilhao.',
    },
    {
      title: 'Ranking de Cotas de FII por Numero de Negocios em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=tradesnumber&timeRange=yearly`,
      pending: false,
      description:
        'Real Investor Recebiveis Imobiliarios RLtda liderou com 35.125 negocios (32,57%), seguido por Permuta Financeira Lote5 RLtda com 29.155 negocios (27,04%).',
    },
    {
      title: 'Ranking de Cotas de FII por Variacao de Preco em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=pricevariance&timeRange=yearly`,
      pending: false,
      description:
        'Capitania Logistica liderou com variacao de +3,13% a.a., seguido por Kinea Rendimentos Imobiliarios (+3,11%). XP Malls (+3,05%) e Maxi Renda (+2,88%) tambem figuraram no topo.',
    },
    {
      title: 'Ranking de Cotas de FII por Dividend Yield Realizado em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=dividendyield&timeRange=yearly`,
      pending: false,
      description:
        'O ranking de dividend yield realizado mostrou dispersao elevada. Edificio Almirante Barroso (FAMB11) apareceu no topo com 57,44%, em contexto de forte desconto de mercado frente ao valor patrimonial.',
    },
    {
      title: 'Ranking de Cotas de FII por Rentabilidade Efetiva em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=effectivereturn&timeRange=yearly`,
      pending: false,
      description:
        'Hedge Brasil Shopping figurou entre os maiores indicadores de rentabilidade efetiva em 2025, com destaque para efeitos de base de preco deprimida em alguns fundos, que inflaram o indicador.',
    },
    {
      title: 'Ranking de Cotas de FII por Capitalizacao de Mercado em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=quotafii&criteria=capitalization&timeRange=yearly`,
      pending: false,
      description:
        'Parque Dom Pedro Shopping Center liderou com 16,03% e R$ 34,83 bilhoes de capitalizacao, seguido por Kinea Rendimentos Imobiliarios (R$ 10,05 bi) e Kinea Indices de Precos (R$ 7,20 bi).',
    },
    {
      title: 'Ranking de FII por Patrimonio Liquido em 2025',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=stock&criteria=amount&timeRange=yearly`,
      pending: false,
      description:
        'XP CDI II FII liderou com 17,99% e R$ 1,38 bilhao, seguido por FII Atria RLtda (15,12% / R$ 1,16 bi) e Oportunidades Imobiliarias I RLtda (12,20% / R$ 932,79 mi).',
    },
    {
      title: 'Ranking de Administradores por Patrimonio Liquido',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=admin&criteria=networthallmarket&timeRange=consolidated`,
      pending: false,
      description:
        'BTG Pactual Servicos Financeiros DTVM liderou com 21,72% e R$ 90,00 bilhoes, seguido por BRL Trust DTVM (R$ 47,59 bi) e XP Investimentos (R$ 46,64 bi).',
    },
    {
      title: 'Ranking de Administradores por Numero de Fundos',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=admin&criteria=fundnumber&timeRange=consolidated`,
      pending: false,
      description:
        'BTG Pactual Servicos Financeiros DTVM tambem liderou em numero de fundos com 210 veiculos, seguido por BRL Trust (113) e Vortx (102).',
    },
    {
      title: 'Ranking de Auditores por Patrimonio Liquido',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=auditor&criteria=networthallmarket&timeRange=consolidated`,
      pending: false,
      description:
        'Ernst & Young liderou com 30,81% e R$ 111,60 bilhoes de PL auditado, seguida por PwC (R$ 77,37 bi) e KPMG (R$ 54,90 bi).',
    },
    {
      title: 'Ranking de Auditores por Numero de Fundos',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=auditor&criteria=fundnumber&timeRange=consolidated`,
      pending: false,
      description:
        'Ernst & Young liderou por numero de fundos com 218 veiculos, seguida por Next Auditores com 203 e PwC com 135.',
    },
    {
      title: 'Ranking de Gestores por Patrimonio Liquido',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=manager&criteria=networthallmarket&timeRange=consolidated`,
      pending: false,
      description:
        'Kinea Investimentos liderou por PL com 8,47% e R$ 34,28 bilhoes, seguida por BTG Pactual Gestora de Recursos (R$ 24,54 bi) e XP Vista Asset Management (R$ 23,09 bi).',
    },
    {
      title: 'Ranking de Gestores por Numero de Fundos',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=manager&criteria=fundnumber&timeRange=consolidated`,
      pending: false,
      description:
        'No numero de fundos, REAG Trust e CBSF Trust apareceram na lideranca com 42 fundos cada, seguidas por Genial Gestao com 39 fundos.',
    },
    {
      title:
        'Ranking de Gestores de FIIs de Renda Fixa por Patrimonio Liquido Consolidado',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=manager_pc&criteria=amountnetworth&timeRange=consolidated`,
      pending: false,
      description:
        'Nos FIIs de Renda Fixa, Kinea liderou o PL consolidado com R$ 26,57 bilhoes, seguida por XP Vista Asset Management (R$ 6,72 bi) e BTG Pactual Gestora de Recursos (R$ 4,70 bi).',
    },
    {
      title:
        'Ranking de Gestores de FIIs de Renda Fixa por Numero de Fundos Consolidado',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=manager_pc&criteria=operations&timeRange=consolidated`,
      pending: false,
      description:
        'No numero de fundos de Renda Fixa, Kinea liderou com 8 fundos, seguida por XP Vista com 7 e Valora Gestao de Investimentos com 6.',
    },
    {
      title:
        'Ranking de Gestores de FIIs de Renda Fixa por Rentabilidade Efetiva',
      link: `${rankingBaseUrl}?market=FII&year=2025&ranking=manager_pc&criteria=irr&timeRange=consolidated`,
      pending: false,
      description:
        'Na rentabilidade efetiva dos FIIs de Renda Fixa, Iguana Investimentos liderou com mediana de 42,95%, seguida por Santander Brasil Gestora de Recursos (40,32%) e Maua Capital Real Estate (37,57%).',
    },
  ],
};
